import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UiActions } from 'app/store/ui/ui.actions';
import { selectBuildDate, selectBuildNumber, selectVersionNumber } from 'app/store/ui/ui.selectors';

@Component({
    selector: 'pulse-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PulseFooterComponent implements OnInit, OnDestroy {

    buildNumber = '';
    buildDate = '';
    versionNumber = '';
    currentYear = new Date().getFullYear();
    private unsubscribe$ = new Subject<void>();

    constructor(private store: Store, private cdr: ChangeDetectorRef) {}

    ngOnInit() {
        this.store.dispatch(UiActions.loadReleaseInfo());
        this.store.select(selectBuildNumber).pipe(takeUntil(this.unsubscribe$)).subscribe(v => { this.buildNumber = v; this.cdr.markForCheck(); });
        this.store.select(selectBuildDate).pipe(takeUntil(this.unsubscribe$)).subscribe(v => { this.buildDate = v; this.cdr.markForCheck(); });
        this.store.select(selectVersionNumber).pipe(takeUntil(this.unsubscribe$)).subscribe(v => { this.versionNumber = v; this.cdr.markForCheck(); });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
